import { BookOpen } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { EpisodeCard } from 'shared/components/EpisodeCard/EpisodeCard';
import { RevealItem } from 'shared/components/RevealItem/RevealItem';
import { FilterPills } from '../components/FilterPills/FilterPills';
import { PublishedEpisode } from 'shared/data/episodes';
import { ALLOW_SUBSCRIPTIONS } from 'shared/constants/common';
import { useAudioPlayerControls } from 'shared/hooks/useAudioPlayer';

type EpisodesCatalogSectionProps = {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  filteredEpisodes: PublishedEpisode[];
  filters: string[];
};

export function EpisodesCatalogSection({
  activeFilter,
  onFilterChange,
  filteredEpisodes,
  filters,
}: EpisodesCatalogSectionProps) {
  const { t } = useTranslation('episodes');
  const { play } = useAudioPlayerControls();
  return (
    <>
      <FilterPills
        filters={filters}
        activeFilter={activeFilter}
        onFilterChange={onFilterChange}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-8 md:mt-16">
        {filteredEpisodes.map((episode, i) => (
          <RevealItem key={episode.number} index={i}>
            <EpisodeCard
              {...episode}
              onPlay={episode.audioUrl ? () => play(episode) : undefined}
            />
          </RevealItem>
        ))}

        {ALLOW_SUBSCRIPTIONS ? <article className="flex flex-col bg-surface-container-high rounded-xl overflow-hidden p-8 border border-tertiary/10 lg:col-span-2 transition-transform duration-300 hover:-translate-y-1">
          <div className="flex flex-col md:flex-row gap-10 items-center">
            <div className="flex-1">
              <span className="text-tertiary font-sans font-bold uppercase tracking-widest text-xs mb-3 block">
                {t('catalog.joinLabel')}
              </span>
              <h3 className="text-3xl font-serif font-bold text-on-surface mb-4 leading-tight">
                {t('catalog.newsletterHeading')}
              </h3>
              <p className="text-on-surface-variant text-sm font-light leading-relaxed mb-6">
                {t('catalog.newsletterDescription')}
              </p>
            </div>
            <div className="w-full md:w-48 h-48 bg-surface-container rounded-full flex items-center justify-center border-4 border-surface shrink-0">
              <BookOpen size={64} className="text-tertiary/40" />
            </div>
          </div>
        </article> : null}
      </div>
    </>
  );
}
